import { render, staticRenderFns } from "./Confirm2Fa.vue?vue&type=template&id=b5e24588&scoped=true"
import script from "./Confirm2Fa.vue?vue&type=script&lang=js"
export * from "./Confirm2Fa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e24588",
  null
  
)

export default component.exports